import React, { Component } from 'react';
import './Site.css';
import { Card, CardHeader, Row, Col, Button, Collapse, Table } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Alert from "react-s-alert";
import { api, filterHelper } from "../helpers";
import { DocumentUpload, Pager } from "../components";

export default class EquipmentDocument extends Component {
  static displayName = EquipmentDocument.name;
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      messageColor: null,
      isMessageVisible: false,
      collapse: false,
      filters: [{
        filterName: "EquipmentId",
        value: props.equipmentId ? props.equipmentId : null,
        filteredDisplay: "Equipment Id"
      },
        {
          filterName: "ActiveOnly",
          value: true,
          filteredDisplay: "Active Only"
        }      ],
      pagedList: null,
      sortColumn: "Name",
      sortAscending: false,
    }
    this.toggleCollapse = this.toggleCollapse.bind(this);
    this.refreshList = this.refreshList.bind(this);
    this.setPage = this.setPage.bind(this);
  }

  componentDidMount() {
    this.refreshList();
  }

  refreshList(sortColumn, sortAscending, filters, pageNumber) {
    const resolvedFilters = filters || this.state.filters;
    const resolvedSort = {
      sortColumn: sortColumn || this.state.sortColumn,
      sortAscending: sortAscending || this.state.sortAscending
    };
    const payload = {
      activeOnly: null,
      name: null,
      ...resolvedSort,
      ...filterHelper.filtersToObject(resolvedFilters),
      pageSize: 5,
      page: pageNumber || (this.state.pagedList ? this.state.pagedList.pageNumber : 1)
    };

    api.post("Equipment/EquipmentDocuments", payload)
      .then(response => {
        if (response.data) {
          this.setState({
            ...resolvedSort,
            pagedList: {
              list: response.data.dataSource,
              pageNumber: response.data.page,
              pageSize: response.data.pageSize,
              totalItems: response.data.totalItems,
              totalPages: response.data.totalPages
            },
            filters: resolvedFilters,
          });
        }
      })
  }

  onDeleteDocument(id) {
    if (!window.confirm(`Are you sure you'd like to delete this document?`))
      return;

    api.delete(`Equipment/DeleteEquipmentDocument/${id}`)
      .then(response => {
        if (response.data.success) {
          Alert.success("Document was deleted.")
          this.refreshList();
        } else {
          Alert.error(response.data.message)
        }
      }).catch(error => {
        Alert.error(`There was an error deleting the document.`)
    });
  }

  setPage(page) {
    this.refreshList(null, null, null, page);
  }

  toggleCollapse() {

    this.setState({
      collapse: !this.state.collapse
    })
  }

  render() {
    return (
      <Card className="p-2 mb-2">
        <CardHeader className="boldText">
          <span className="mr-2"><FontAwesomeIcon icon={"file-alt"} className="" title={`Documents`} /></span>
          Documents
            <Button size="sm" className="float-right cbdmdSuccess" onClick={() => this.toggleCollapse()}>{this.state.recordsCollapse ? "View Less" : "View More"}</Button>
        </CardHeader>
        <Collapse isOpen={this.state.collapse}>
          <Row className="p-2 mt-2">
            {!this.props.viewOnly &&
              <Col>
                <DocumentUpload title={"Document"} equipmentId={this.props.equipmentId} uploadUrl={"Equipment/UploadEquipmentDocument"} refresh={this.refreshList} />
              </Col>
            }
            <Col>
              <Table>
                <thead>
                  <tr>
                    <th>File Name</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.pagedList && this.state.pagedList.list &&
                    this.state.pagedList.list.length > 0 ? (
                      this.state.pagedList.list.map(document => (
                        <tr key={`doc-${document.id}`}>
                          <td>
                            <div>
                              <span>{document.fileName}</span>
                              <span className="float-right">
                                <a target="#" href={document.signedUrl}>
                                  <FontAwesomeIcon
                                    icon="external-link-alt"
                                    className="mr-2 cbdmdBlueText cursor"
                                    title="View Document"
                                  />
                                </a>
                                {this.props.viewOnly ? null :
                                  <FontAwesomeIcon
                                    icon="trash-alt"
                                    title="Delete Document"
                                    className="mr-2 cbdmdDangerText cursor"
                                    onClick={() => this.onDeleteDocument(document.id)}
                                  />
                                }
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr><td className="details">No documents found</td></tr>
                    )}
                </tbody>
              </Table>
              <Pager {...this.state.pagedList} callBack={this.setPage} />
            </Col>
          </Row>
        </Collapse>
      </Card>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/EquipmentDocument.js